import React from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import {  Grid} from "@material-ui/core";
import { VendorBlockExcemptionViewData } from "../../../models/VendorBlocking/VendorBlockExcemptionViewData";
import { VendorRequestViewMode } from "../../../constants/AppConstants";

interface BlockExceptionDataProp {
  blockExcemptionData: VendorBlockExcemptionViewData;
  vendorDetailMode: VendorRequestViewMode;
}

export default function BlockExcemptionData(props: BlockExceptionDataProp) {
  const classes = useStyles();
  const { blockExcemptionData, vendorDetailMode } = props;

  const concateDataList = (datalist: any) => {
    if (datalist && datalist.length > 0) {
      let concatstring = datalist.join(",");
      return concatstring;
    }
    return "";
  };

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.formOneWrapper}
      >
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_blocking_co_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{blockExcemptionData.companyCode}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_blocking_po_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {concateDataList(blockExcemptionData.poCodes)}
            </span>
          </Grid>
        </Grid>


        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_excemption_extension_reason_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {blockExcemptionData.extensionReason}
            </span>
          </Grid>
        </Grid>
        
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_block_excemption_extension_period_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>
              {(blockExcemptionData.extensionPeriod)+" Months"}
            </span>
          </Grid>
        </Grid>
        
      </Grid>
    </div>
  );
}
